export default (obj, method, params) => (typeof obj[method] === 'function' ? obj[method](params) : null);
